import { z } from 'zod';

// ---------------------------------------------------------------------------
// Industry templates
// ---------------------------------------------------------------------------

/**
 * Industry templates a workspace can start from (sign-up, Settings, Hive provisioning). Each seeds the
 * first brand's suggested audiences and content pillars; the content lives in `@marketingbee/domain`
 * (`templates`). This list is mirrored in `_shared/catalog.json` as `templates.marketingbee.industries` (a drift test compares
 * them), so change both together.
 */
export const INDUSTRY_TEMPLATES = [
  { id: 'general', label: 'General business' },
  { id: 'beauty', label: 'Beauty & skincare' },
  { id: 'wellness', label: 'Wellness & supplements' },
  { id: 'fitness', label: 'Fitness' },
  { id: 'food-beverage', label: 'Food & beverage' },
  { id: 'home-services', label: 'Home services' },
  { id: 'professional-services', label: 'Professional services' },
  { id: 'saas-marketplace', label: 'Software / marketplace' },
] as const satisfies readonly { id: string; label: string }[];

export type IndustryTemplateId = (typeof INDUSTRY_TEMPLATES)[number]['id'];
export const INDUSTRY_TEMPLATE_IDS = INDUSTRY_TEMPLATES.map((t) => t.id) as [
  IndustryTemplateId,
  ...IndustryTemplateId[],
];
export const industryTemplateId = z.enum(INDUSTRY_TEMPLATE_IDS);

export function isIndustryTemplateId(value: unknown): value is IndustryTemplateId {
  return typeof value === 'string' && (INDUSTRY_TEMPLATE_IDS as readonly string[]).includes(value);
}

export const applyTemplateInput = z.object({ id: industryTemplateId });
